"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var copy_to_clipboard_1 = __importDefault(require("copy-to-clipboard"));
var react_i18next_1 = require("react-i18next");
var core_1 = require("@material-ui/core");
var copy_svg_1 = __importDefault(require("@assets/widgets/user/copy.svg"));
var OnClickTooltip_1 = __importDefault(require("./OnClickTooltip"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return core_1.createStyles({
        copyLinkDiv: (_a = {
                color: '#FFC700',
                display: 'flex'
            },
            // marginRight: theme.spacing(2),
            _a[theme.breakpoints.up('md')] = {
            // marginRight: 30,
            },
            _a),
        copyIcon: {
            marginLeft: 5,
            width: function (props) { return props.iconSize; },
        },
        urlText: {
            maxWidth: '200px',
            color: theme.palette.primary.main,
        },
    });
});
function CopyButton(_a) {
    var iconSize = _a.iconSize, buttonText = _a.buttonText, shortUrl = _a.shortUrl, stopPropagation = _a.stopPropagation, variant = _a.variant, _b = _a.showButtonText, showButtonText = _b === void 0 ? true : _b;
    var _c = __read(react_i18next_1.useTranslation(), 1), t = _c[0];
    var classes = useStyles({ iconSize: iconSize });
    var urlToCopy = document.location.protocol + "//" + document.location.host + "/" + shortUrl;
    return (react_1.default.createElement(OnClickTooltip_1.default, { tooltipText: t('text.shortLinkCopy') },
        react_1.default.createElement(core_1.Button, { onClick: function (e) {
                copy_to_clipboard_1.default(urlToCopy);
                if (stopPropagation) {
                    e.stopPropagation();
                }
            } },
            react_1.default.createElement("div", { className: classes.copyLinkDiv },
                react_1.default.createElement(core_1.Typography, { variant: variant || 'subtitle2', className: classes.urlText, noWrap: true }, showButtonText ? buttonText || urlToCopy : ''),
                react_1.default.createElement("img", { className: classes.copyIcon, src: copy_svg_1.default, alt: "Copy short link" })))));
}
exports.default = CopyButton;
